import { FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '_metronic/helpers'
import { useThemeMode } from '_metronic/partials'

const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat']

const Error404: FC = () => {
  const { mode } = useThemeMode()

  useEffect(() => {
    BODY_CLASSES.forEach(c => document.body.classList.add(c))
    document.body.style.backgroundImage =
      mode === 'dark'
        ? `url(${toAbsoluteUrl('/media/auth/bg7-dark.jpg')})`
        : `url(${toAbsoluteUrl('/media/auth/bg7.jpg')})`

    return () => {
      BODY_CLASSES.forEach(c => document.body.classList.remove(c))
      document.body.style.backgroundImage = 'none'
    }
  }, [mode])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush  w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              {/* begin::Title */}
              <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Error</h1>
              {/* end::Title */}

              {/* begin::Text */}
              <div className='fw-semibold fs-4 text-gray-500 mb-7'>คุณไม่มีสิทธิสามารถใช้งานได้</div>
              {/* end::Text */}

              {/* begin::Illustration */}
              {/* <div className='mb-3'>
                <img
                  src={toAbsoluteUrl('/media/auth/404-error.png')}
                  className='mw-100 mh-300px theme-light-show'
                  alt=''
                />
                <img
                  src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
                  className='mw-100 mh-300px theme-dark-show'
                  alt=''
                />
              </div> */}
              {/* end::Illustration */}

              {/* begin::Link */}
              <div className='mb-0'>
                <Link to='/home' className='btn btn-sm btn-primary'>
                  กลับหน้าหลัก
                </Link>
              </div>
              {/* end::Link */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Error404 }
